import {TaxAuditRecordDetailsResponse} from "src/models/reports/TaxAuditRecordDetails";
import {Box, Container, Header} from "@amzn/awsui-components-react";
import {TPELoadingSpinner} from "src/components/shared/TPELoadingSpinner";
import React from "react";

function ValueWithLabel(props: any) {
    const { label } = props;
    return (
        <div>
            <Box margin={{ bottom: 'xxxs' }} color="text-label">
                {label}
            </Box>
            <div>{props.children}</div>
        </div>
    );
}

export default function TaxAuditRecordTaxProductDetails(props: { taxAuditRecordDetails: TaxAuditRecordDetailsResponse, loading: boolean}) {
    const {taxAuditRecordDetails, loading} = props;

    return <Container
        header={
            <Header variant="h2">Tax Product Details</Header>
        }>
        <div className="polaris-content-container-tar-report-details">
            <TPELoadingSpinner loading={loading}>
                {taxAuditRecordDetails != null &&
                    <React.Fragment>
                        <div className="grid-item"><ValueWithLabel label="Tax Category">{taxAuditRecordDetails.taxCategory}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Tax Category ID">{taxAuditRecordDetails.taxCategoryID}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Tax Sub Category">{taxAuditRecordDetails.taxSubCategory}</ValueWithLabel></div>
                        <div className="grid-item"><ValueWithLabel label="Tax SubCategory ID">{taxAuditRecordDetails.taxSubCategoryID}</ValueWithLabel></div>
                    </React.Fragment>
                }
            </TPELoadingSpinner>
        </div>
    </Container>
}